import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { oAuth } from "../../../routes/basic/BasicAppRouter";
import auctions, {
  getPastProducts,
} from "../../../services/ProductsApiService";
import { MobileSignIn } from "../../../pages/zipang/Header/ZipangHeader";
import Alert from "../../../common/elements/Alert";

const SidebarLink = styled.div`
  display: flex;
  color: #000f7e;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  font-size: 20px;
  height: 40px;
  &:hover {
    color: lightgrey !important;
    cursor: pointer;
  }
  ::selection {
    color: lightgrey !important;
    text-decoration: underline;
  }
`;

const SidebarLabel = styled.span``;

const DropdownLink = styled.div`
  text-align: center;
  justify-content: center;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #000f7e;
  font-size: 16px !important;
  &:hover {
    color: lightgrey !important;
    cursor: pointer;
  }
  ::selection {
    color: lightgrey !important;
    text-decoration: underline;
  }
`;

var userType: string | null = "";
var isProfileComplete: string | null = "";

const MobileMenus = ({ item, closeDrawer }: any) => {
  const [subnav, setSubnav] = useState(false);
  const [showSignIn, setShowSignIn] = useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState("");
  const { t } = useTranslation();
  const history = useHistory();

  userType = localStorage.getItem("isNormalUser");
  isProfileComplete = localStorage.getItem("profileComplete");

  const clearFilterStorage = () => {
    localStorage.removeItem("filteredValues");
    localStorage.removeItem("filteredParcelValues");
    localStorage.removeItem("currentStart");
    localStorage.removeItem("itemsPerPage");
  };
  let languageCode =
    localStorage.getItem("language") === "EN"
      ? "en"
      : localStorage.getItem("language") === "zh_CN"
      ? "zh_CN"
      : "jp";
  const headerButtonHandler = async (routeName: string) => {
    if (
      oAuth() === false &&
      routeName !== "/home" &&
      routeName !== "/preview"
    ) {
      setShowSignIn(true);

      const localizedUrl = `/${languageCode}${routeName}`;
      localStorage.setItem("postLoginRedirect", localizedUrl);
    } else if (routeName === "/preview") {
      try {
        //  1. Check ongoing auctions
        const auctionlist = await auctions();

        if (auctionlist?.results?.length > 0) {
          const {
            auctionType,
            id: auctionId,
            auctionUserId,
            name: auctionName,
            startDate: auctionDate,
          } = auctionlist.results[auctionlist.results.length - 1];

          if (auctionType && auctionType !== "Live") {
            history.push({
              pathname: `/preview/tendor/products/${auctionId}/${auctionUserId}/${auctionName}/${auctionDate}`,
            });
          } else {
            history.push({
              pathname: `/preview/products/${auctionId}/${encodeURIComponent(
                auctionName
              )}/${encodeURIComponent(auctionDate)}`,
            });
          }
          return; // stop execution
        }

        // 2. If no ongoing auction → check past auctions
        const pastAuctionProducts = await getPastProducts();

        if (pastAuctionProducts?.results?.length > 0) {
          history.push({
            pathname: "/publicpreview/pastproducts",
            search: "?pastProducts=true",
          });
          return;
        }

        //  3. If neither ongoing nor past auctions
        setShowAlertMessage("No Ongoing  Auction found");
        setOpenToast(true);
        setTimeout(() => {
          setOpenToast(false);
        }, 3000);
        setTimeout(() => {
          history.push("/home");
        }, 3000);
      } catch (err) {
        console.error("Error fetching auctions:", err);
        setShowAlertMessage("Something went wrong. Please try again later.");
        setOpenToast(true);
      }
    } else {
      history.push(routeName);
    }
  };
  const handleSigninClose = () => {
    setShowSignIn(false);
    localStorage.removeItem("postLoginRedirect");
  };

  const handleClick = async (route: string) => {
    if (item.isAuctiontab) {
      clearFilterStorage();
    }

    await headerButtonHandler(route);
    if (closeDrawer) closeDrawer(); // close drawer after navigation
  };

  const renderIconAndText = () => {
    return <SidebarLabel>{t(item.title)}</SidebarLabel>;
  };

  if (!item) return null;

  return (
    <>
      {userType === "normal" ? (
        <SidebarLink
          onClick={() =>
            item.subNav ? setSubnav(!subnav) : handleClick(item.path)
          }
          className={
            history.location.pathname.includes(item.path) ? "is-active" : ""
          }
        >
          {renderIconAndText()}
        </SidebarLink>
      ) : isProfileComplete === "true" ? (
        <SidebarLink
          onClick={() =>
            item.subNav ? setSubnav(!subnav) : handleClick(item.path)
          }
          className={
            history.location.pathname.includes(item.path) ? "is-active" : ""
          }
        >
          {renderIconAndText()}
        </SidebarLink>
      ) : (
        <div>
          {item.isAuctiontab ? (
            <>
              {renderIconAndText()}
              {t("common:menu:auction")}
            </>
          ) : (
            <SidebarLink
              onClick={() =>
                item.subNav ? setSubnav(!subnav) : handleClick(item.path)
              }
              className={
                history.location.pathname.includes(item.path) ? "is-active" : ""
              }
            >
              {renderIconAndText()}
            </SidebarLink>
          )}
        </div>
      )}

      {subnav &&
        item.subNav?.map((child: any, index: number) => (
          <DropdownLink
            key={index}
            onClick={() => handleClick(child.path)}
            className={
              history.location.pathname.includes(child.path) ? "is-active" : ""
            }
          >
            <SidebarLabel>{t(child.title)}</SidebarLabel>
          </DropdownLink>
        ))}
      <MobileSignIn show={showSignIn} onClose={handleSigninClose} />
      {openToast === true && (
        <Alert showAlertMessage={showAlertMessage} alertType={"error"} />
      )}
    </>
  );
};

export default MobileMenus;
